import { render, staticRenderFns } from "./Viewer.vue?vue&type=template&id=b56683f2&"
import script from "./Viewer.vue?vue&type=script&lang=ts&"
export * from "./Viewer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports